import { render, staticRenderFns } from "./MtrlEditAppr.vue?vue&type=template&id=87c1d18a&scoped=true&"
import script from "./MtrlEditAppr.vue?vue&type=script&lang=js&"
export * from "./MtrlEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1d18a",
  null
  
)

export default component.exports